// components
import HeadText from "../components/HeadText";
import Sub from "../components/Sub";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Vibe } from "../components/memories";
import "../App.css";

// ----------------------------------------------------------------------

export default function MemoriesPage({
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
}) {
  return (
    <>
      <Header
        web3Modal={web3Modal}
        loadWeb3Modal={loadWeb3Modal}
        logoutOfWeb3Modal={logoutOfWeb3Modal}
      />
      <div className="page">
        <HeadText title={"MEMORIES"} />
        <Sub
          title1={"THIS IS WHAT WE LIVE AND"}
          title2={"BREATHE. THIS IS OUT VIBE"}
          title3={""}
        />
        <Vibe />
      </div>

      <Footer />
    </>
  );
}
